import { BCMSDate } from "@bcm-dev/bcms-vite";
import Week from "../Week";
import "./styles.css";
 // :: bcmsDate,bcmsDate,bcmsDate,bcmsDate -> [WEEKS]
 //Creates a weeks worth of Days adds properties to the days for disabling and labels for fees;
let key =0;
 function getWeek(date,setDate,currentMonth){
    let week = [];  
    let viewDate = date;
    do{
      let newDate =BCMSDate.init(viewDate)
       week.push({newDate,setDate,currentMonth})
        viewDate.offset(1)
       
    }
    while(viewDate.getLongDay !== "Sunday")
    return week;
  }

 // :: bcmsDate,bcmsDate -> [WEEKS]
 //Creates a months worth of weeks as an array to map over 
 function getMonth(viewDate,setDate){
    let newDate = BCMSDate.init(viewDate); 
    let lastDay = BCMSDate.init(viewDate).setToLast();
    let firstDay = BCMSDate.init(newDate.setToFirst());
    do{      
        newDate.offset(-1)
     
    }
    while(newDate.isAfter(firstDay) || newDate.getLongDay   !== "Sunday")
    let month = [];
  
    do{
        
        month.push(getWeek(newDate,setDate,viewDate))       
    }
    while(newDate.isBefore(lastDay))
    return month;
  }
  
export default function Month(props){
    let {setDate,viewDate,onChange,controllers} = props ;
    let month =getMonth(viewDate,setDate);
 
    return(
      <div>        
        <div className="flex-container day-of-the-week-header">
            <span className="flex-width square">Sun</span>
            <span className="flex-width square">Mon</span>
            <span className="flex-width square">Tues</span>
            <span className="flex-width square">Wed</span>
            <span className="flex-width square">Thu</span>
            <span className="flex-width square">Fri</span>
            <span className="flex-width square">Sat</span>
        </div>
          {month.map( function(days,index)  {     
           key++;           
            return <div className="row flex-container space-between"  key={key.toString()} >  <Week days = {days} onChange={onChange} controllers={controllers}/></div>
          })}
      </div>
      )
  } 